import styled from "styled-components";

export const PlainStyledButton = styled.button`
    color: rgb(232, 23, 93, 1);
    border: none;
    padding: 10px;
    border-radius: 10px;
    background: transparent;
    font-size: 15px!important;
    font-weight: bold;
    cursor: pointer;
`;